import { fg } from '@atlaskit/platform-feature-flags/fg';

import { FormFieldType } from '../../../../../../common/types/form/form-fields';
import type {
	FormFieldComponentRenderer,
	FormFieldComponentRendererConfig,
} from '../../../../../../common/types/renderers';
import { UnknownRenderer } from './unknown-renderer';

export const getFormFieldComponentRenderer = (
	fieldType: FormFieldType,
	customFormFieldComponentRendererConfig?: FormFieldComponentRendererConfig,
	defaultFormFieldComponentRendererConfig?: FormFieldComponentRendererConfig,
): FormFieldComponentRenderer => {
	if (
		!fg('phx-3346_proforma_rating_question_type') &&
		(fieldType === FormFieldType.RATING || fieldType === FormFieldType.SCALE)
	) {
		return UnknownRenderer;
	}

	if (customFormFieldComponentRendererConfig === undefined) {
		return typeof defaultFormFieldComponentRendererConfig === 'object'
			? defaultFormFieldComponentRendererConfig[fieldType] || UnknownRenderer
			: defaultFormFieldComponentRendererConfig || UnknownRenderer;
	}

	if (typeof customFormFieldComponentRendererConfig === 'object') {
		const customFormFieldTypeComponentRenderer = customFormFieldComponentRendererConfig[fieldType];
		if (customFormFieldTypeComponentRenderer === undefined) {
			return typeof defaultFormFieldComponentRendererConfig === 'object'
				? defaultFormFieldComponentRendererConfig[fieldType] || UnknownRenderer
				: defaultFormFieldComponentRendererConfig || UnknownRenderer;
		}

		return customFormFieldTypeComponentRenderer;
	}

	return customFormFieldComponentRendererConfig;
};
